'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoPieGraph = function IoPieGraph(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm0.1 20c0-0.4-0.1-0.9-0.1-1.2 0-9 7.3-16.3 16.3-16.3 0.3 0 0.8 0.1 1.2 0.1v17.4h-17.4z m6 11.4c-2-2.5-3.3-5.5-3.5-8.9h17.4v-17.4c3.4 0.2 6.4 1.5 8.9 3.5 3.7 3 6.1 7.5 6.1 12.7 0 8.9-7.3 16.2-16.2 16.2-5.2 0-9.7-2.4-12.7-6.1z' })
        )
    );
};

exports.default = IoPieGraph;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/pie-graph.js
// module id = 2859
// module chunks = 168707334958949